import '../app/components/Tooltip.css';
import '../app/style.css';
import React from 'react';
import { Route } from 'react-router-dom';
import { Locale, Spinner, Provider as TacoProvider } from '@economic/taco';
import { AuthRoutes } from '@economic/react-app';
import { fetchLocalisation } from '~/fetchLocalisation';
import { DataProvider } from '~/app/shared/components/DataContext';
import { NotFound } from './pages/NotFound';

const Document = React.lazy(() => import(/* webpackChunkName: "external.document" */ './pages/Document/Document'));
const SmartBank = React.lazy(() => import(/* webpackChunkName: "external.smartbank" */ './pages/SmartBank'));
const PaymentTakeover = React.lazy(() => import(/* webpackChunkName: "external.paymenttakeover" */ './pages/PaymentTakeover'));

export default function External() {
    // the user is unauthenticated, so we use defaults
    const tacoLocalisation = fetchLocalisation('en-GB' as Locale, 'dd.mm.yy');
    const tacoSettings = { uniqueUserIdentifier: 'unauthenticated' };

    return (
        <React.Suspense fallback={<Spinner className="w-full p-8" />}>
            <TacoProvider localization={tacoLocalisation} settings={tacoSettings}>
                <DataProvider>
                    <AuthRoutes>
                        <Route path="document/:key" element={<Document />} />
                        <Route path="smartbank/:key" element={<SmartBank />} />
                        <Route path="paymenttakeover/:key" element={<PaymentTakeover />} />
                        <Route path="*" element={<NotFound />} />
                    </AuthRoutes>
                </DataProvider>
            </TacoProvider>
        </React.Suspense>
    );
}
